import { Backdrop, CircularProgress, CircularProgressProps, Dialog } from '@mui/material';
import { ReactNode } from 'react';

interface ProgressProps extends CircularProgressProps {
    isLoading: boolean;
    children?: ReactNode;
    overlay?: boolean;
}

const Progress = ({ isLoading, children, overlay, ...other }: ProgressProps): JSX.Element => {

    if (overlay) {
        return (
            <>
                <>{children}</>
                <Backdrop sx={{ color: (theme) => theme.palette.primary.dark, zIndex: (theme) => theme.zIndex.drawer + 1, position: "absolute" }} open={isLoading}>
                    <CircularProgress {...other} />
                </Backdrop>
            </>
        );
    }

    return isLoading ? <CircularProgress {...other}></CircularProgress> : <>{children}</>;
};

export default Progress;
